import ReportBase from 'app/models/report_base';

export default ReportBase.extend({
  reportType: 'fulfillment_third_party_failed_order',
  reportTypeReadable: 'Fulfillment Marketplace Failed Order Report',
});



// WEBPACK FOOTER //
// ./app/models/fulfillment_third_party_failed_order_report.js